import React from "react";
import { motion } from "framer-motion";

// Scroll-reveal wrapper: fade + slide up + gentle scale.
export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", once = true }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y, scale: 0.985 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

// Staggered container for card grids.
export const StaggerGroup = ({ children, className = "", stagger = 0.1 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: stagger } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 30 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y, scale: 0.97 },
      show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } },
    }}
  >
    {children}
  </motion.div>
);
